module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-468a4f6ae8cf78af8d7a332846d661c3.png";